exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\ncode[data-v-e46cca9a] {\n  background: #eee;\n  padding: 3px 6px;\n  font-size: 16px;\n  border-radius: 5px;\n  color: #666;\n}\n", "", {"version":3,"sources":["/opt/build/repo/src/components/methods/MethodChoice.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;CACb","file":"MethodChoice.vue","sourcesContent":["\ncode[data-v-e46cca9a] {\n  background: #eee;\n  padding: 3px 6px;\n  font-size: 16px;\n  border-radius: 5px;\n  color: #666;\n}\n"],"sourceRoot":""}]);

// exports
